import React from "react";
import { Button } from "@mui/material";
import PieChartIcon from "@mui/icons-material/PieChart";
import BarChartIcon from "@mui/icons-material/BarChart";
import ShowChartIcon from "@mui/icons-material/ShowChart";

const ButtonStyle = {
  padding: "3px 3px",
  margin: "0 5px",
  flex: "1",
  fontSize: "10px",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const IconStyle = {
  fontSize: "15px",
  border: "1px solid white",
  marginTop: "8px",
};

const IconMapping = {
  PieChartIcon: PieChartIcon,
  BarChartIcon: BarChartIcon,
  ShowChartIcon: ShowChartIcon,
};

export const ReportsButton = ({
  handleButtonClick,
  buttonType,
  title,
  icon = null,
}) => {
  const getIcon = () => {
    if (icon && IconMapping.hasOwnProperty(icon)) {
      const IconComponent = IconMapping[icon];
      return <IconComponent style={IconStyle} />;
    }
    return null;
  };

  return (
    <Button
      style={ButtonStyle}
      variant={"contained"}
      color={"primary"}
      onClick={() => handleButtonClick(buttonType)}
    >
      {title}
      {getIcon()}
    </Button>
  );
};
